/**
 * Template Service - Manages template storage and operations using localStorage
 */

const TEMPLATES_KEY = 'ad_builder_templates';

// Sample templates for testing
const SAMPLE_TEMPLATES = [
  {
    id: 'sample-template-1',
    name: 'Circle Product Showcase',
    createdAt: new Date().toISOString(),
    thumbnail: null,
    json: {
      "width": 1080,
      "height": 1080,
      "fonts": [],
      "pages": [
        {
          "id": "sample-page-1",
          "children": [
            {
              "id": "bg-image-1",
              "type": "image",
              "name": "background",
              "opacity": 1,
              "visible": true,
              "selectable": true,
              "removable": true,
              "alwaysOnTop": false,
              "showInExport": true,
              "x": -146.15309549119874,
              "y": -213.1587764139238,
              "width": 1290.8346433267402,
              "height": 1936.2519649901108,
              "rotation": 0,
              "src": "https://images.unsplash.com/photo-1762803733564-fecc7669a91a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wxMTY5OTZ8MHwxfGFsbHw1fHx8fHx8fHwxNzYyOTUxNDE1fA&ixlib=rb-4.1.0&q=80&w=1080",
              "keepRatio": false,
              "custom": {
                "isVariable": false
              }
            },
            {
              "id": "product-image-1",
              "type": "image",
              "name": "product-image",
              "opacity": 1,
              "visible": true,
              "selectable": true,
              "removable": true,
              "alwaysOnTop": false,
              "showInExport": true,
              "x": 135,
              "y": 0,
              "width": 810,
              "height": 1080,
              "rotation": 0,
              "src": "https://via.placeholder.com/810x1080",
              "clipSrc": "data:image/svg+xml;base64,CiAgICA8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiPgogICAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtMC44MTA0OTM4MTEwMDMwMDc1Ij4KICAgICAgPHBhdGggZD0iTSAxNTAgMTUwIG0gLTE1MCwgMCBhIDE1MCwxNTAgMCAxLDAgMzAwLDAgYSAxNTAsMTUwIDAgMSwwIC0zMDAsMCIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgoKICA8IS0tIFBhdGggZm9yIHRoZSBmaWxsIC0tPgogIDxwYXRoIGQ9Ik0gMTUwIDE1MCBtIC0xNTAsIDAgYSAxNTAsMTUwIDAgMSwwIDMwMCwwIGEgMTUwLDE1MCAwIDEsMCAtMzAwLDAiIGZpbGw9InJnYmEoMTkxLCAxOTEsIDE5MSwgMTAwKSIgdHJhbnNmb3JtPSJzY2FsZSgxLCAxKSIvPgoKICA8IS0tIFBhdGggZm9yIHRoZSBzdHJva2UsIGNsaXBwZWQgYnkgdGhlIHN0YXIgcGF0aCAtLT4KICA8cGF0aCBkPSJNIDE1MCAxNTAgbSAtMTUwLCAwIGEgMTUwLDE1MCAwIDEsMCAzMDAsMCBhIDE1MCwxNTAgMCAxLDAgLTMwMCwwIiBmaWxsPSJub25lIiBzdHJva2U9IiMwYzBjMGMiIHN0cm9rZS13aWR0aD0iMCIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtMC44MTA0OTM4MTEwMDMwMDc1KSIgdHJhbnNmb3JtPSJzY2FsZSgxLCAxKSIgc3Ryb2tlLWRhc2hhcnJheT0iIi8+CiAgICA8L3N2Zz4KICA=",
              "keepRatio": true,
              "custom": {
                "isVariable": true,
                "variableName": "image",
                "variableType": "image",
                "imageIndex": 0
              }
            },
            {
              "id": "brand-text-1",
              "type": "text",
              "name": "brand",
              "x": 100,
              "y": 900,
              "width": 880,
              "height": 60,
              "rotation": 0,
              "text": "{brand}",
              "fontSize": 48,
              "fontFamily": "Arial",
              "fontWeight": "bold",
              "fill": "#000000",
              "align": "center",
              "custom": {
                "isVariable": true,
                "variableName": "brand",
                "variableType": "text"
              }
            },
            {
              "id": "price-text-1",
              "type": "text",
              "name": "price",
              "x": 100,
              "y": 970,
              "width": 880,
              "height": 50,
              "rotation": 0,
              "text": "{price}",
              "fontSize": 40,
              "fontFamily": "Arial",
              "fill": "#8E0DFF",
              "align": "center",
              "custom": {
                "isVariable": true,
                "variableName": "price",
                "variableType": "text"
              }
            }
          ],
          "width": 1080,
          "height": 1080,
          "background": "white"
        }
      ],
      "unit": "px",
      "dpi": 72
    },
    variableMap: {
      "product-image-1": {
        type: 'image',
        variableName: 'image',
        imageIndex: 0
      },
      "brand-text-1": {
        type: 'text',
        variableName: 'brand'
      },
      "price-text-1": {
        type: 'text',
        variableName: 'price'
      }
    },
    productId: null
  },
  {
    id: 'sample-template-2',
    name: 'Minimal Product Card',
    createdAt: new Date().toISOString(),
    thumbnail: null,
    json: {
      "width": 1080,
      "height": 1080,
      "fonts": [],
      "pages": [
        {
          "id": "sample-page-2",
          "children": [
            {
              "id": "product-image-2",
              "type": "image",
              "name": "product-main",
              "x": 90,
              "y": 90,
              "width": 900,
              "height": 600,
              "rotation": 0,
              "src": "https://via.placeholder.com/900x600",
              "keepRatio": true,
              "custom": {
                "isVariable": true,
                "variableName": "image",
                "variableType": "image",
                "imageIndex": 0
              }
            },
            {
              "id": "title-text-2",
              "type": "text",
              "name": "title",
              "x": 90,
              "y": 720,
              "width": 900,
              "height": 80,
              "rotation": 0,
              "text": "{title}",
              "fontSize": 42,
              "fontFamily": "Arial",
              "fontWeight": "bold",
              "fill": "#000000",
              "align": "left",
              "custom": {
                "isVariable": true,
                "variableName": "title",
                "variableType": "text"
              }
            },
            {
              "id": "description-text-2",
              "type": "text",
              "name": "description",
              "x": 90,
              "y": 820,
              "width": 900,
              "height": 100,
              "rotation": 0,
              "text": "{description}",
              "fontSize": 24,
              "fontFamily": "Arial",
              "fill": "#666666",
              "align": "left",
              "custom": {
                "isVariable": true,
                "variableName": "description",
                "variableType": "text"
              }
            },
            {
              "id": "price-text-2",
              "type": "text",
              "name": "price",
              "x": 90,
              "y": 940,
              "width": 400,
              "height": 60,
              "rotation": 0,
              "text": "{price}",
              "fontSize": 48,
              "fontFamily": "Arial",
              "fontWeight": "bold",
              "fill": "#8E0DFF",
              "align": "left",
              "custom": {
                "isVariable": true,
                "variableName": "price",
                "variableType": "text"
              }
            }
          ],
          "width": 1080,
          "height": 1080,
          "background": "#F5F5F5"
        }
      ],
      "unit": "px",
      "dpi": 72
    },
    variableMap: {
      "product-image-2": {
        type: 'image',
        variableName: 'image',
        imageIndex: 0
      },
      "title-text-2": {
        type: 'text',
        variableName: 'title'
      },
      "description-text-2": {
        type: 'text',
        variableName: 'description'
      },
      "price-text-2": {
        type: 'text',
        variableName: 'price'
      }
    },
    productId: null
  }
];

/**
 * Initialize templates in localStorage if not exists
 */
const initializeTemplates = () => {
  const existing = localStorage.getItem(TEMPLATES_KEY);
  if (!existing) {
    localStorage.setItem(TEMPLATES_KEY, JSON.stringify(SAMPLE_TEMPLATES));
  }
};

/**
 * Get all templates from localStorage
 */
export const getTemplates = () => {
  initializeTemplates();
  const data = localStorage.getItem(TEMPLATES_KEY);
  return data ? JSON.parse(data) : [];
};

/**
 * Get a specific template by ID
 */
export const getTemplate = (id) => {
  const templates = getTemplates();
  return templates.find(t => t.id === id);
};

/**
 * Save a new template
 */
export const saveTemplate = (name, json, variableMap, productId = null) => {
  const templates = getTemplates();
  
  const newTemplate = {
    id: `template-${Date.now()}`,
    name,
    createdAt: new Date().toISOString(),
    thumbnail: null, // Could generate thumbnail from canvas later
    json,
    variableMap,
    productId
  };
  
  templates.push(newTemplate);
  localStorage.setItem(TEMPLATES_KEY, JSON.stringify(templates));
  
  return newTemplate;
};

/**
 * Update an existing template
 */
export const updateTemplate = (id, updates) => {
  const templates = getTemplates();
  const index = templates.findIndex(t => t.id === id);
  
  if (index !== -1) {
    templates[index] = { ...templates[index], ...updates };
    localStorage.setItem(TEMPLATES_KEY, JSON.stringify(templates));
    return templates[index];
  }
  
  return null;
};

/**
 * Delete a template
 */
export const deleteTemplate = (id) => {
  const templates = getTemplates();
  const filtered = templates.filter(t => t.id !== id);
  localStorage.setItem(TEMPLATES_KEY, JSON.stringify(filtered));
  return true;
};

/**
 * Format price with currency
 */
const formatPrice = (price, currency = 'USD') => {
  if (typeof price !== 'number') return price;
  
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  } catch (e) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  }
};

/**
 * Get variable value from product data
 */
const getVariableValue = (variableName, product) => {
  const mapping = {
    'brand': product.vendor || 'N/A',
    'title': product.title || 'Product Title',
    'price': formatPrice(product.min_price || 0, product.currency || 'INR'),
    'sale_price': formatPrice(product.min_price || 0, product.currency || 'INR'),
    'description': (product.description || '')
      .replace(/<[^>]*>/g, '')
      .substring(0, 200)
  };
  
  return mapping[variableName] || '';
};

/**
 * Apply template to a product and return modified JSON
 */
export const applyTemplateToProduct = (templateId, product) => {
  const template = getTemplate(templateId);
  if (!template) {
    throw new Error('Template not found');
  }
  
  // Deep clone the template JSON
  const modifiedJson = JSON.parse(JSON.stringify(template.json));
  
  // Process each page
  modifiedJson.pages.forEach(page => {
    page.children.forEach(element => {
      const varConfig = template.variableMap[element.id];
      
      if (varConfig) {
        if (varConfig.type === 'text') {
          // Replace text variable
          const value = getVariableValue(varConfig.variableName, product);
          element.text = value;
        } else if (varConfig.type === 'image') {
          // Replace image variable
          const images = product.images || [];
          const imageIndex = varConfig.imageIndex || 0;
          
          if (images[imageIndex] && images[imageIndex].src) {
            element.src = images[imageIndex].src;
            element.visible = true;
          } else {
            // Hide element if image not available
            element.visible = false;
          }
        }
      }
    });
  });
  
  return modifiedJson;
};

const templateService = {
  getTemplates,
  getTemplate,
  saveTemplate,
  updateTemplate,
  deleteTemplate,
  applyTemplateToProduct
};

export default templateService;
